var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FDF4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1767 28.4528C23.6323 28.9084 23.6323 29.6471 23.1767 30.1027C22.7211 30.5583 21.9824 30.5583 21.5268 30.1027L14.5268 23.1027C14.0851 22.661 14.0696 21.9498 14.4917 21.4894L20.9084 14.4894C21.3438 14.0144 22.0818 13.9823 22.5567 14.4177C23.0317 14.8531 23.0638 15.5911 22.6284 16.0661L16.9666 22.2426L23.1767 28.4528Z",
    fill: "#FFBD37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.6017 21.1111C19.9574 21.1111 19.4351 21.6334 19.4351 22.2778C19.4351 22.9221 19.9574 23.4444 20.6017 23.4444H28.1851C28.8294 23.4444 29.3517 23.9668 29.3517 24.6111V36.3263C29.3517 36.9706 29.8741 37.4929 30.5184 37.4929C31.1627 37.4929 31.6851 36.9706 31.6851 36.3263V24.6111C31.6851 22.6781 30.1181 21.1111 28.1851 21.1111H20.6017Z",
    fill: "#FFBD37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/Process.34026348d23aeef549cbea2152374757.svg";
export { ForwardRef as ReactComponent };